import { useCallback } from 'react';

import useErrorHandler from '$app-web/hooks/use-error-handler';

import useReadStudyBasicInfoEndpoint from './use-read-study-basic-info.endpoint';

const useReadStudyBasicInfo = (studyId, onSuccess) => {
    const { handleError } = useErrorHandler();

    const { refetch, isLoading, isSuccess, isError, data, ...rest } = useReadStudyBasicInfoEndpoint(
        {
            studyId,
        },
        {
            enabled: false,
            onSuccess: (result) => {
                onSuccess && onSuccess(result);
            },
            onError: (error) => handleError(error),
        }
    );

    const readStudyBasicInfo = useCallback(() => {
        refetch();
    }, [refetch]);

    return {
        readStudyBasicInfo,
        isLoading,
        isSuccess,
        isError,
        data: data || {},
        hasStudyBasicInfo: !!data,
        ...rest,
    };
};

export default useReadStudyBasicInfo;
